import React from 'react';
import './Features.css';

const Features = () => {
  const programHighlights = [
    {
      icon: '🎤',
      title: 'Panels & Keynotes',
      description: 'Hear from leading founders, investors, and ecosystem enablers as they share insights on navigating the challenges of building startups in Africa — from funding and scaling to leadership and product growth.'
    },
    {
      icon: '🚀',
      title: 'Startup Pitch Session',
      description: 'Selected early-stage founders will pitch their startups to a panel of investors, mentors, and ecosystem leaders. This is more than just a pitch — it\'s a spotlight for innovation and connection.'
    },
    {
      icon: '🍸',
      title: 'Evening Mixer',
      description: 'Networking made meaningful. The evening mixer brings together all attendees — founders, investors, and builders — in an informal setting to connect, collaborate, and form relationships.'
    }
  ];

  return (
    <section id="expect" className="features">
      <div className="container">
        <h2>What to Expect</h2>
        <p className="features-subtitle">
          A day packed with insights, connections, and opportunities to build the future.
        </p>
        
        <div className="features-grid">
          {programHighlights.map((highlight, index) => (
            <div key={index} className="feature-card">
              <div className="feature-icon">{highlight.icon}</div>
              <h3>{highlight.title}</h3>
              <p>{highlight.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
